import React from 'react';
import { ButtonGroup, Icon, modals, VStack, HStack, Button, Box, Text } from '@cad-arc';
import { AttachmentDto } from '@mark43/cad-api';
import { getFileName, getAttachmentIcon } from './helpers';
import { formatMonthDayYearHoursMinutes } from '../common/helpers/utils';

export function showDeleteAttachmentConfirmationModal({
    attachment,
    onConfirm,
    cancelButtonRef,
    isLoading = false,
}: {
    attachment: AttachmentDto;
    onConfirm: () => void;
    cancelButtonRef: React.MutableRefObject<HTMLButtonElement | null>;
    isLoading?: boolean;
}): void {
    const body = (
        <VStack spacing={4} align="start">
            <Text>Are you sure you want to delete this file permanently?</Text>
            <HStack spacing={3} p={3} bg="gray.50" borderRadius="md" width="100%">
                <Box
                    w={10}
                    h={10}
                    bg="red.500"
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    color="white"
                    fontSize="sm"
                    fontWeight="bold"
                >
                    <Icon icon={getAttachmentIcon(attachment)} />
                </Box>
                <VStack align="start" spacing={0} flex={1}>
                    <Text>{getFileName(attachment)}</Text>
                    <Text>
                        {attachment.createdBy}{' '}
                        {formatMonthDayYearHoursMinutes(attachment.createdDateUtc)}
                    </Text>
                </VStack>
            </HStack>
        </VStack>
    );

    modals.modal({
        initialFocusRef: cancelButtonRef,
        title: 'Delete file',
        body,
        footer: (props) => (
            <ButtonGroup>
                <Button
                    ref={cancelButtonRef}
                    onClick={() => {
                        props.onClose();
                    }}
                    isDisabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    variant="solid"
                    onClick={() => {
                        onConfirm();
                        props.onClose();
                    }}
                    colorVariant="dangerous"
                    isLoading={isLoading}
                >
                    Yes, Delete This File
                </Button>
            </ButtonGroup>
        ),
    });
}
